const htmlBody = document.querySelector('#viewEveryoneMailing').querySelector('div[name=body]');
import auth from '../tools/storage.js';
// import auth from '../tools/storage.js';

export default {

  cleanContainer() {
    htmlBody.innerHTML = '';
  },

  getElement(item, index) {


   return `<div class="reference-header  w-100 m-0 p-1 " mID=${item.id} numReq=${item.numRequest}> 
            <div  class="reference-column m-0 p-0" numReq=${item.numRequest}> 
              <label mID=${item.id}  numReq=${item.numRequest} class=" p-0 m-0 iconGroupOfConsider">${item.numRequest}</label>
            </div>  
            <label  mID=${item.id} numReq=${item.numRequest} class="reference-column m-0 p-0 pl-1">${item.name} <b class=" ml-auto mr-3">${item.mail}</b>  </label>
            <label class ="w-10 m-0" numReq=${item.numRequest}  mID=${item.id}  >
              <u class="w-100 txt-al-center buttonU removeU" action="remove"  mID=${item.id} >удалить</u> 
            </label>
          </div>`;
  },

  drawDataInContainer(servAvnswer) {
    this.cleanContainer();
    htmlBody.innerHTML = `<div class="reference-header  w-100 m-0 p-1 " > 
            <div  class="reference-column m-0 p-0"> 
              <label class=" p-0 m-0 iconGroupOfConsider">№</label>
            </div>  
            <label class="reference-column m-0 p-0 pl-1">Название  <b class=" ml-auto mr-0">E-mail</b></label>
            <label  class="reference-column m-0 p-0 pl-1 w-10"></label>
      
          </div>`;;
    if(servAvnswer)
      servAvnswer.forEach((item, index) => htmlBody.insertAdjacentHTML('beforeend', this.getElement(item, index)));
    // htmlBody.insertAdjacentHTML('beforeend', '</div>');
  },

  drawMarkupInContainer(markup) {
    htmlBody.insertAdjacentHTML('beforeend', markup);
  },

};



